import SearchObj from 'Components/common/search/SearchObj';

/**
 * @description 查询方法混入
 * @author: 菩萨蛮
 * @date 2020/11/3 11:15 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */


const SearchMixins = {
  methods: {
    getGoodNameSearchValue(item) {
      return new SearchObj(
        'goodname', '物品名称', item, 'input', item
      ).tags;
    },
    getGoodsTypeSearchValue(item) {
      return new SearchObj(
        'goodsType', '物品类型', item, 'select', item
      ).tags;
    },
    getCurrencyUnitSearchValue(item) {
      return new SearchObj(
        'currencyUnit', '货币类型', item, 'select', item
      ).tags;
    },
    getCustomerSearchValue(item) {
      return new SearchObj(
        'custName', '客户名称', item, 'input', ''
      ).tags;
    },
    getCustUserNameSearchValue(item) {
      return new SearchObj(
          'custUserName', '客户负责人', item, 'input', ''
      ).tags;
    }
  }
};

export default SearchMixins;
